import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import FormBuilder from '../../../../common/form-builder/FormBuilder';

export default function ThrustersForm() {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const thrustersNumberField = [
    {
      class:
        'col-md-3 col-sm-6 col-lg-3 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'thrustersNumber',
      label: t('labels.thrustersNumber'),
      control: control,
      fieldType: 'number',
    },
  ];

  const blankFields = [
    {
      class:
        'col-md-3 col-sm-6 col-lg-3 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'blankSixteen',
      label: t('labels.blankSixteen'),
      control: control,
      fieldType: 'number',
      allowDecimal: true,
    },
    {
      class:
        'col-md-3 col-sm-6 col-lg-3 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'blankSeventeen',
      label: t('labels.blankSeventeen'),
      control: control,
      fieldType: 'text',
    },
    {
      class:
        'col-md-3 col-sm-6 col-lg-3 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'blankEighteen',
      label: t('labels.blankEighteen'),
      control: control,
      fieldType: 'text',
    },
  ];

  return (
    <>
      <div className="row">
        <FormBuilder formConfig={thrustersNumberField} />
      </div>
      <div className="row">
        <div className="row m-l-custom-eight-space-row u-mb-xl">
          <div className="m-l-details-page-sepeartor"></div>
        </div>
        <FormBuilder formConfig={blankFields} />
      </div>
    </>
  );
}
